export default __webpack_public_path__ + "static/create-workflow-30230070082b63628c5259df1f136f34.png";